// Generated by tools/as3-to-ts from work/decomp/main/scripts/FWP.as (FWP.init_data_arrays, line 2058); hand-edits allowed (see docs/architecture.md)

/** `this.BOOKS_DEF` literal from FWP.init_data_arrays. Returns a fresh copy on every call (the game mutates it). */
export function create_BOOKS_DEF(): any {
  return {
    "obj_red_book": {
      "mode": "craft",
      "param": [4, 17, 19, 20, 21]
    },
    "obj_orange_book": {
      "mode": "craft",
      "param": [4, 29, 30, 31, 33]
    },
    "obj_yellow_book": {
      "mode": "craft",
      "param": [4, 1, 2, 4, 6]
    },
    "obj_green_book": {
      "mode": "craft",
      "param": [4, 10, 14, 15, 16]
    },
    "obj_skyblue_book": {
      "mode": "craft",
      "param": [4, 36, 37, 38, 40]
    },
    "obj_blue_book": {
      "mode": "craft",
      "param": [4, 53, 55, 76, 74]
    },
    "obj_violet_book": {
      "mode": "craft",
      "param": [4, 59, 67, 69, 71]
    },
    "obj_white_book": {
      "mode": "craft",
      "param": [3, 79, 80, 84]
    },
    "obj_black_book": {
      "mode": "craft",
      "param": [3, 86, 87, 88]
    }
  };
}
